import { Box } from '@mui/material';
import React, { useState } from 'react';
import useWebContext from '../../hooks/useWebContext';
import { MyMCloseButton } from '../../ui-elements/MyMButton';
import { MyMLink } from '../../ui-elements/MyMLink';
import { MyMModal } from '../../ui-elements/MyMModal';
import { PagingDataGrid } from '../../ui-parts/PagingDataGrid';
import { utility } from '../../utility';
import UserInfo from '../MyM204_UserInfo/UserInfo';

/**  
 * MyMine Version1.5 UserListフィルタ・ページング対応
 * UserListSearchResult Component
 */
export const UserListSearchResult = React.memo((props) => {
  const {
    screenId,
    userList,
    sortModel,
    setSortModel,
    pageNumber,
    setPageNumber,
    isUserListLoading,
  } = props;
  const { controlSettings, messageList } = useWebContext(screenId);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUserSeqNo, setSelectedUserSeqNo] = useState();
  const [filterModel, setFilterModel] = useState({ items: [] });

  const handlePageChange = (pageNum) => {
    setPageNumber(pageNum);
  };

  const onClickUserId = (userSequenceNo) => {
    // UserInfoModalを開く
    setSelectedUserSeqNo(userSequenceNo);
    setIsModalOpen(true);
  }

  /** ModalCloseイベント */
  const handleModalClose = () => setIsModalOpen(false);

  /** UserInfoでのUser更新コールバック処理 */
  const callbackUpdateUser = () => setSortModel([...sortModel]);

  const columns = [
    {
      field: "USER_ID",
      headerName: controlSettings.LabelList.lnkUserIdHeader,
      minwidth: 100,
      flex: 1,
      sortable: true,
      renderCell: (params) => <MyMLink onClick={() => onClickUserId(params.row.id)}>{params.row.USER_ID}</MyMLink>,
    },
    {
      field: "USER_NAME",
      headerName: controlSettings.LabelList.lblNameHeader,
      minwidth: 100,
      flex: 1,
      sortable: true,
    },
    {
      field: "COMPANY_NAME_DISP",
      headerName: controlSettings.LabelList.lblCompanyHeader,
      minwidth: 100,
      flex: 1,
      sortable: true,
    },
    {
      field: "ROLE_NAME",
      headerName: controlSettings.LabelList.lblRoleHeader,
      minwidth: 100,
      flex: 1,
      sortable: true,
    },
    {
      field: "STATUS_NAME",
      headerName: controlSettings.LabelList.lblStatusHeader,
      minwidth: 100,
      flex: 1,
      sortable: true,
    },
    {
      field: "LAST_LOGIN_DATE",
      headerName: controlSettings.LabelList.lblLatestLoggedinDateHeader,
      minwidth: 100,
      flex: 1,
      sortable: true,
      type: 'datetime',
    },
  ];

  /** 一覧の内容定義 */
  const dataList = userList.ItemList.map((row) => {
    return {
      id: row.UserSequenceNo,
      USER_ID: row.UserId,
      USER_NAME: `${row.FirstName ?? ''} ${row.LastName ?? ''}`.trim(),
      COMPANY_NAME_DISP: row.CompanyNameDisp,
      ROLE_NAME: row.RoleName,
      STATUS_NAME: row.StatusName,
      LAST_LOGIN_DATE: utility.formatDateTime(row.LastLoginDate, 'yyyy/MM/dd HH:mm')
    }
  });

  return (
    <Box sx={{ width: '100%', padding: '25px 40px 0px 40px' }}>
      <>
        <Box sx={{ height: '68vh' }}>
          <PagingDataGrid
            // DataGrid用
            columns={columns}
            dataList={dataList}
            sortModel={sortModel}
            handleSortModelChange={(newSortModel) => setSortModel(newSortModel)}
            uniquyKey={(row) => row.id}
            disableColumnMenu={true}
            disableColumnSelector={true}
            filterModel={filterModel}
            handleFilterModelChange={(newFilterModel) => setFilterModel(newFilterModel)}
            isLoading={isUserListLoading}
            sx={{ marginBottom: '5px' }}
            disableColumnResize={true}
            // Pager用
            resultListItem={userList}
            handlePageChange={handlePageChange}
            labelList={controlSettings.LabelList}
            messageList={messageList}
            pageNumber={pageNumber}
          />
        </Box>
      </>
      <Box align='right' marginTop='1rem' marginRight='1rem'>
        <MyMCloseButton closeText={controlSettings.LabelList.btnClose} />
      </Box>
      <MyMModal
        open={isModalOpen}
        onClose={handleModalClose}
        width='65%'
        height='63%'
      >
        <UserInfo
          handleModalClose={handleModalClose}
          userSeqNo={selectedUserSeqNo}
          callbackUpdateUser={callbackUpdateUser}
        />
      </MyMModal>
    </Box>
  )
}
)